module.exports = __webpack_public_path__ + "static/media/SM-ST1-TRIAL-if-wrong.0d6c5d86.mp3";